module.exports = __webpack_public_path__ + "static/post-82258005b3a9b2f44c2b77c1173bd35a.svg";